import { createStyles, makeStyles } from "@mui/styles";
import { headerFontFamily } from "styles/theme/mui";

export const homeHeaderTypography = {
  fontFamily: headerFontFamily,
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "23.12px",
  letterSpacing: 0,
  textAlign: "right" as const,
};

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#F4F5F8",
      direction: "rtl",
      overflow: "hidden",
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#F4F5F8",
      overflow: "hidden",
    },

    topbarWrapper: {
      width: "100%",
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 100,
      background: "#FFFFFF",
    },

    scrollContent: {
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
      padding: 0,
      boxSizing: "border-box",
      background: "#F4F5F8",
      display: "flex",
      flexDirection: "column",
    },

    pageContent: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      gap: 16,
      opacity: 1,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
      overflow: "hidden",
    },

    pageBody: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      gap: 16,
      overflow: "hidden",
    },

    noPermissionRoot: {
      flex: 1,
      minHeight: 0,
      padding: "16px 24px 24px",
      boxSizing: "border-box",
      background: "#F4F5F8",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflowY: "auto",
    },

    bottomGrid: {
      width: "100%",
      flex: 1,
      minHeight: 0,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 16,
      alignItems: "start",
    },

    pageTitle: {
      fontSize: "24px !important",
      fontWeight: "600 !important",
      color: "#1E2A44",
    },
  })
);
